import { Injectable, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ServiceErrorPopupComponent } from "@app/view/shared/service-error-popup/service-error-popup.component";
import { HttpErrorResponse } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class ServiceErrorHandlerService {
  private dialog = inject(MatDialog);

  public handleError(
    error: { action: string; params: {} } | HttpErrorResponse
  ) {
    console.log("Handling error");
    console.log(error);
    let matDialogRef = this.dialog.open(ServiceErrorPopupComponent, {
      data: {
        error: error
      }
    });
    matDialogRef.afterClosed().subscribe(() => {
      console.log("error dismissed");
    });
  }

  public handleClientError(error: string) {
    console.log("Handling error");
    console.log(error);
    let matDialogRef = this.dialog.open(ServiceErrorPopupComponent, {
      data: {
        title: "Error",
        error: error
      }
    });
    matDialogRef.afterClosed().subscribe(() => {
      console.log("error dismissed");
    });
  }

  public handleClientInfo(message: string, title = "Information") {
    let matDialogRef = this.dialog.open(ServiceErrorPopupComponent, {
      data: {
        title: title,
        error: message
      }
    });
    matDialogRef.afterClosed().subscribe(() => {
      console.log("message dismissed");
    });
  }
}
